import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'shared/components/modals';
import {FormLayout, Input} from 'shared/components';
import {EmployeeSelector} from 'main/components';
import {t} from 'shared/core';

const EditDimensionValueModal = observer(({uiState, modalOpen}) => {
  const {errors, editingDimensionValue} = uiState;

  return (
    <Modal
      isOpen={modalOpen}
      onHide={() => uiState.closeEditDimensionValueModal()}
      size='sm'
      title={editingDimensionValue.isNew
        ? 'time_tracking.dimensions.directory.Create Value'
        : 'time_tracking.dimensions.directory.Edit Value'
      }
    >
      <FormLayout>
        <Input
          value={editingDimensionValue.name}
          label='time_tracking.dimensions.directory.Name'
          errorMessage={errors.name}
          onChange={e => editingDimensionValue.merge({name: e.target.value})}
        />
        <EmployeeSelector
          label={t('time_tracking.dimensions.directory.Employees')}
          tooltip={{
            paragraphs: [t('time_tracking.dimensions.directory.ASSIGNED_EMPLOYEES_TOOLTIP')]
          }}
          selectedEmployees={editingDimensionValue.employees}
          onChange={employees => uiState.editingDimensionValue.employees = employees}
        />
      </FormLayout>
      <ModalButtons onSave={() => uiState.saveDimensionValue()} onCancel={() => uiState.closeEditDimensionValueModal()}/>
    </Modal>
  );
});

export default EditDimensionValueModal;
